"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _Output_id, _Output_inputValidator, _Output_logger, _Output_name, _Output_session, _Output_sessionEngine, _Output_uuidGenerator, _Output_bbmax, _Output_bbmin, _Output_chunks, _Output_content, _Output_delay, _Output_dependency, _Output_displayname, _Output_hidden, _Output_material, _Output_msg, _Output_order, _Output_status_collect, _Output_status_computation, _Output_tooltip, _Output_uid, _Output_updateCallback, _Output_version;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Output = void 0;
const tsyringe_1 = require("tsyringe");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
class Output {
    // #endregion Properties (24)
    // #region Constructors (1)
    constructor(session, sessionEngine, outputDef) {
        // #region Properties (24)
        _Output_id.set(this, void 0);
        _Output_inputValidator.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.InputValidator));
        _Output_logger.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.Logger));
        _Output_name.set(this, void 0);
        _Output_session.set(this, void 0);
        _Output_sessionEngine.set(this, void 0);
        _Output_uuidGenerator.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.UuidGenerator));
        _Output_bbmax.set(this, void 0);
        _Output_bbmin.set(this, void 0);
        _Output_chunks.set(this, void 0);
        _Output_content.set(this, void 0);
        _Output_delay.set(this, void 0);
        _Output_dependency.set(this, void 0);
        _Output_displayname.set(this, void 0);
        _Output_hidden.set(this, false);
        _Output_material.set(this, void 0);
        _Output_msg.set(this, void 0);
        _Output_order.set(this, void 0);
        _Output_status_collect.set(this, void 0);
        _Output_status_computation.set(this, void 0);
        _Output_tooltip.set(this, void 0);
        _Output_uid.set(this, void 0);
        _Output_updateCallback.set(this, null);
        _Output_version.set(this, void 0);
        try {
            __classPrivateFieldSet(this, _Output_session, session, "f");
            __classPrivateFieldSet(this, _Output_sessionEngine, sessionEngine, "f");
            __classPrivateFieldSet(this, _Output_id, outputDef.id, "f");
            __classPrivateFieldSet(this, _Output_name, outputDef.name, "f");
            __classPrivateFieldSet(this, _Output_version, outputDef.version, "f");
            this.updateOutputDefinition(outputDef);
            __classPrivateFieldGet(this, _Output_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).constructor: Initialized output ${JSON.stringify(outputDef)}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Output_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${outputDef.id}).constructor`, e);
        }
    }
    // #endregion Constructors (1)
    // #region Public Accessors (27)
    get bbmax() {
        return __classPrivateFieldGet(this, _Output_bbmax, "f");
    }
    get bbmin() {
        return __classPrivateFieldGet(this, _Output_bbmin, "f");
    }
    get chunks() {
        return __classPrivateFieldGet(this, _Output_chunks, "f");
    }
    get content() {
        return __classPrivateFieldGet(this, _Output_content, "f");
    }
    get delay() {
        return __classPrivateFieldGet(this, _Output_delay, "f");
    }
    get dependency() {
        return __classPrivateFieldGet(this, _Output_dependency, "f");
    }
    get displayname() {
        return __classPrivateFieldGet(this, _Output_displayname, "f");
    }
    set displayname(value) {
        try {
            __classPrivateFieldGet(this, _Output_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).displayname: Updating DisplayName to ${value}.`);
            __classPrivateFieldGet(this, _Output_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).displayname`, value, 'string', false);
            __classPrivateFieldSet(this, _Output_displayname, value, "f");
            __classPrivateFieldGet(this, _Output_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).displayname: DisplayName was updated to ${this.displayname}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Output_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${this.id}).displayname`, e);
        }
    }
    get freeze() {
        return __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputsFreeze[__classPrivateFieldGet(this, _Output_id, "f")];
    }
    set freeze(value) {
        try {
            __classPrivateFieldGet(this, _Output_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).freeze: Updating Freeze to ${value}.`);
            __classPrivateFieldGet(this, _Output_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).freeze`, value, 'boolean');
            __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputsFreeze[__classPrivateFieldGet(this, _Output_id, "f")] = value;
            __classPrivateFieldGet(this, _Output_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).freeze: Freeze was updated to ${this.freeze}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Output_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${this.id}).freeze`, e);
        }
    }
    get hidden() {
        return __classPrivateFieldGet(this, _Output_hidden, "f");
    }
    set hidden(value) {
        try {
            __classPrivateFieldGet(this, _Output_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).hidden: Updating Hidden to ${value}.`);
            __classPrivateFieldGet(this, _Output_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).hidden`, value, 'boolean');
            __classPrivateFieldSet(this, _Output_hidden, value, "f");
            __classPrivateFieldGet(this, _Output_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).hidden: Hidden was updated to ${this.hidden}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Output_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${this.id}).hidden`, e);
        }
    }
    get id() {
        return __classPrivateFieldGet(this, _Output_id, "f");
    }
    get material() {
        return __classPrivateFieldGet(this, _Output_material, "f");
    }
    get msg() {
        return __classPrivateFieldGet(this, _Output_msg, "f");
    }
    get name() {
        return __classPrivateFieldGet(this, _Output_name, "f");
    }
    get node() {
        return __classPrivateFieldGet(this, _Output_session, "f").node.children.find(c => c.name === this.id);
    }
    get order() {
        return __classPrivateFieldGet(this, _Output_order, "f");
    }
    set order(value) {
        try {
            __classPrivateFieldGet(this, _Output_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).order: Updating Order to ${value}.`);
            __classPrivateFieldGet(this, _Output_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).order`, value, 'number', false);
            __classPrivateFieldSet(this, _Output_order, value, "f");
            __classPrivateFieldGet(this, _Output_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).order: Order was updated to ${this.order}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Output_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${this.id}).order`, e);
        }
    }
    get status_collect() {
        return __classPrivateFieldGet(this, _Output_status_collect, "f");
    }
    get status_computation() {
        return __classPrivateFieldGet(this, _Output_status_computation, "f");
    }
    get tooltip() {
        return __classPrivateFieldGet(this, _Output_tooltip, "f");
    }
    set tooltip(value) {
        try {
            __classPrivateFieldGet(this, _Output_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).tooltip: Updating tooltip to ${value}.`);
            __classPrivateFieldGet(this, _Output_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).tooltip`, value, 'string', false);
            __classPrivateFieldSet(this, _Output_tooltip, value, "f");
            __classPrivateFieldGet(this, _Output_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).tooltip: tooltip was updated to ${this.tooltip}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Output_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${this.id}).tooltip`, e);
        }
    }
    get uid() {
        return __classPrivateFieldGet(this, _Output_uid, "f");
    }
    get updateCallback() {
        return __classPrivateFieldGet(this, _Output_updateCallback, "f");
    }
    set updateCallback(value) {
        try {
            __classPrivateFieldGet(this, _Output_logger, "f").debugLow(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).updateCallback: Updating updateCallback to ${value}.`);
            __classPrivateFieldGet(this, _Output_inputValidator, "f").validateAndError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).updateCallback`, value, 'function', false);
            __classPrivateFieldSet(this, _Output_updateCallback, value, "f");
            __classPrivateFieldGet(this, _Output_logger, "f").debug(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${__classPrivateFieldGet(this, _Output_id, "f")}).updateCallback: updateCallback was updated to ${this.updateCallback}.`);
        }
        catch (e) {
            if (e instanceof viewer_shared_services_1.ShapeDiverViewerError || e instanceof viewer_shared_services_1.ShapeDiverBackendError)
                throw e;
            throw __classPrivateFieldGet(this, _Output_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${this.id}).updateCallback`, e);
        }
    }
    get version() {
        return __classPrivateFieldGet(this, _Output_version, "f");
    }
    // #endregion Public Accessors (27)
    // #region Public Methods (2)
    updateOutput(newNode, oldNode) {
        const outputDef = __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputs[this.id];
        this.updateOutputDefinition(outputDef);
        if (__classPrivateFieldGet(this, _Output_updateCallback, "f"))
            __classPrivateFieldGet(this, _Output_updateCallback, "f").call(this, newNode, oldNode);
    }
    updateOutputContent(outputContent, preventUpdate = false) {
        return __awaiter(this, void 0, void 0, function* () {
            __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputs[this.id].content = outputContent;
            __classPrivateFieldGet(this, _Output_sessionEngine, "f").outputs[this.id].version = __classPrivateFieldGet(this, _Output_uuidGenerator, "f").create();
            if (!preventUpdate)
                yield __classPrivateFieldGet(this, _Output_session, "f").updateOutputs();
            return this.node;
        });
    }
    // #endregion Public Methods (2)
    // #region Private Methods (1)
    updateOutputDefinition(outputDef) {
        __classPrivateFieldSet(this, _Output_dependency, outputDef.dependency, "f");
        __classPrivateFieldSet(this, _Output_uid, outputDef.uid, "f");
        __classPrivateFieldSet(this, _Output_material, outputDef.material, "f");
        __classPrivateFieldSet(this, _Output_chunks, outputDef.chunks, "f");
        __classPrivateFieldSet(this, _Output_msg, outputDef.msg, "f");
        if (__classPrivateFieldGet(this, _Output_msg, "f") !== undefined)
            __classPrivateFieldGet(this, _Output_logger, "f").warn(viewer_shared_services_1.LOGGINGTOPIC.OUTPUT, `Output(${this.id}): ${__classPrivateFieldGet(this, _Output_msg, "f")}`);
        __classPrivateFieldSet(this, _Output_bbmin, outputDef.bbmin, "f");
        __classPrivateFieldSet(this, _Output_bbmax, outputDef.bbmax, "f");
        __classPrivateFieldSet(this, _Output_status_computation, outputDef.status_computation, "f");
        __classPrivateFieldSet(this, _Output_status_collect, outputDef.status_collect, "f");
        __classPrivateFieldSet(this, _Output_content, outputDef.content, "f");
        __classPrivateFieldSet(this, _Output_delay, outputDef.delay, "f");
        __classPrivateFieldSet(this, _Output_version, outputDef.version, "f");
        __classPrivateFieldSet(this, _Output_displayname, outputDef.displayname, "f");
        __classPrivateFieldSet(this, _Output_order, outputDef.order, "f");
        __classPrivateFieldSet(this, _Output_hidden, outputDef.hidden, "f");
    }
}
exports.Output = Output;
_Output_id = new WeakMap(), _Output_inputValidator = new WeakMap(), _Output_logger = new WeakMap(), _Output_name = new WeakMap(), _Output_session = new WeakMap(), _Output_sessionEngine = new WeakMap(), _Output_uuidGenerator = new WeakMap(), _Output_bbmax = new WeakMap(), _Output_bbmin = new WeakMap(), _Output_chunks = new WeakMap(), _Output_content = new WeakMap(), _Output_delay = new WeakMap(), _Output_dependency = new WeakMap(), _Output_displayname = new WeakMap(), _Output_hidden = new WeakMap(), _Output_material = new WeakMap(), _Output_msg = new WeakMap(), _Output_order = new WeakMap(), _Output_status_collect = new WeakMap(), _Output_status_computation = new WeakMap(), _Output_tooltip = new WeakMap(), _Output_uid = new WeakMap(), _Output_updateCallback = new WeakMap(), _Output_version = new WeakMap();
//# sourceMappingURL=Output.js.map